// Initialise agGrid for angularJs
agGrid.LicenseManager.setLicenseKey("Using_this_AG_Grid_Enterprise_key_( AG-048319 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( FIDELITY INFORMATION SERVICES, LLC )_is_granted_a_( Multiple Applications )_Developer_License_for_( 15 )_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_AG_Grid_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_( 15 )_Production_Environments___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 21 December 2024 )____[v2]_MTczNDczOTIwMDAwMA==51ed311912f9c6ca454f32b3df7af389");
agGrid.initialiseAgGridWithAngular1(angular);

// templates module
// Contains compiled html for all *.html
// Except for nav.tpl.html which is specific to individual brands
angular.module("templates", []);

// Declares main app module and dependencies
angular.module("app", [
    "ngSanitize",
    "ngRoute",
    "ngCookies",
    "ngAnimate",
    "ngMessages",
    "templates",
    "toastr",
    "ngIdle",
    "ui.bootstrap",
    "ui.bootstrap.tabs",
    "ya.treeview",
    "ya.treeview.tpls", //'ya.treeview.breadcrumbs', 'ya.treeview.breadcrumbs.tpls',
    "angularMoment",
    "ngFileUpload",
    "ngStorage",
    "ui.select",
    "ui.codemirror",
    "SignalR",
    "agGrid",
    "formly",
    "formlyBootstrap",
    "ngProgress",
    "daterangepicker",
    "treeControl",
    "contextMenu",
    "angular-confirm",
    "Scope.safeApply",
    // TODO: Remove fsrc and get rid of this
    // 'rgkevin.datetimeRangePicker',
    // 'ui.bootstrap.datetimepicker',
    "ui.bootstrap.datepickerPopup",
    "ui.bootstrap.timepicker",
    "ui.bootstrap.dropdown",
    "ng.epoch",
    "rzSlider",
]);

angular.module("app").run(function (browserCaps, $window) {
    // We don't support HTML4 or IE <= 9
    if (
        (browserCaps.isIe() && browserCaps.getVersion() <= 9) ||
        !browserCaps.cutsTheMustard()
    ) {
        $window.location.href = "UnsupportedBrowser.html";
    }
});

// JWT handling. See https://helpdesk.clear2pay.com/helpdesk/browse/OTSUTP-2393
const FIS_EXPIRED_HEADER_NAME = 'FIS-Token-Expired';

angular
    .module('app')
    .factory('authInterceptor', function ($rootScope, $q, $window, $browser, $injector) {
        var inflightAuthRequest = null;
        return {
            'responseError': function (response) {
                if (response.status === 401 && response.headers(FIS_EXPIRED_HEADER_NAME)) {
                    var refreshUrl = 'api/auth/RefreshToken';

                    // Absolute token expiry works by returning a 401 with 'FIS-Token-Expired' (same as the normal token expiry response)
                    // So we have to have a special case here to catch any errors on this call. It essentially means time to logout since
                    // nothing will work anyway. Order is also important - we can't let it fall into the same flow as every other API call
                    if (response.config.url.indexOf(refreshUrl) > -1) {
                        $window.location = $browser.baseHref() + 'Account/LogoffView';
                    }

                    // Token has expired. Go get a new one and repeat the request
                    const $http = $injector.get('$http');
                    var deferred = $q.defer();
                    if (!inflightAuthRequest) {
                        inflightAuthRequest = $http.post(refreshUrl, null);
                    }
                    
                    inflightAuthRequest.then(function(authResponse) {
                        inflightAuthRequest = null;

                        if (authResponse.status === 200) {
                            $http(response.config).then(function(resp) {
                                deferred.resolve(resp);
                            },function(resp) {
                                deferred.reject();
                            });
                        } else {
                            deferred.reject();
                        }
                    }, function(response) {
                        inflightAuthRequest = null;
                        deferred.reject();
                        return;
                    });
                    return deferred.promise;       
                }
                // if we get here we have an error response that we dont want to intercept we reject the promise 
                return $q.reject(response);  
            }
        };
    }).config(function ($httpProvider) {
        $httpProvider.interceptors.push('authInterceptor');
    });

angular.module("app").run(function (Idle, $log, $cookies, $window) {
    // Starts the idle watch service to log users out after a period of inactivity
    Idle.watch();

    var loggedInAndIframeAdjustLoop = setInterval(function () {
        // Adjust the height of the RUF iframe based off the remaining height (full height - nav bar container)
        // This gives the impression that the iframe scrollbar is actually the page scrollbar
        var iframe = angular.element(document).find(".iframe-full");

        if (iframe) {
            var navBarHeight = angular.element(document).find("nav-bar nav").height();
            iframe.css("top", navBarHeight + "px");
            iframe.css("height", "calc(100vh - " + navBarHeight + "px)");
        }
        
        // Keeps legacy in sync with RUF - this item will only be present when a user interaction occurs on the RUF
        // side
        if (localStorage.getItem("wbt.idleReset") === "true") {
            Idle.interrupt();
            localStorage.removeItem("wbt.idleReset");
        }

        /* 
         The only page they should be able to see without this cookie is the login or logged out page. So if it's not present 
         and they are trying to get anything but the login page we'll redirect them to the LoggedOffView which will result in a 
         further re-direction to Account/Login if IDP is enabled.
        
         We used to do this check in $rootScope.$on('$routeChangeStart', ...) but doing it every second instead 
         gives us the nice benefit of automatically logging out - meaning we don't have to wait for the user to 
         trigger a route change. This means when RUF has logged out or they log out in another tab we catch it 
         here too.
        */
        var cookie = $cookies.get("loggedInFlag");

        var logoutURL = "Account/LoggedOffView";
        var loginURL = "Account/Login";

        // Need to be careful with the URL here. In installed versions it will be /OTS.UTP/Account/LoggedOffView or /OTS.UTP/Account/Login
        // - dev version will be just /Account/LoggedOffView or /Account/Login

        var currentUrl = _.trim($window.location.pathname, "/#");
   
        if (!_.endsWith(currentUrl.toLowerCase(), loginURL.toLowerCase()) && !_.endsWith(currentUrl.toLowerCase(), logoutURL.toLowerCase())) {
            if (_.isNil(cookie) || cookie.toLowerCase() === "false") {
                $window.location = logoutURL;
                clearInterval(loggedInAndIframeAdjustLoop);
            }
        }
    }, 1000);

    $log.log("Idle.watch() started");
});

// NOTE: Configure the auto-logout service
angular
    .module("app")
    .run(function ($http) {
        $http.defaults.headers.common["X-XSRF-Token"] = angular
            .element('input[name="__RequestVerificationToken"]')
            .attr("value");
        localStorage.setItem(
            "ruf",
            angular
                .element('input[name="__RequestVerificationToken"]')
                .attr("value")
        );
    })
    .config(function (
        $logProvider,
        $compileProvider,
        IdleProvider,
        TitleProvider,
        $uibTooltipProvider
    ) {
        var isDebug = true;
        // Ref: https://stackoverflow.com/questions/15561853/how-to-turn-on-off-log-debug-in-angularjs
        // NOTE: Use $log.debug and then switch on/off with the following
        $logProvider.debugEnabled(isDebug);
        //NOTE: https://docs.angularjs.org/guide/production
        $compileProvider.debugInfoEnabled(isDebug);
        // NOTE: We do not have access to $http here so just use jquery
        $.get("api/app/IdleInfo", function (response) {
            // NOTE: Zero is illegal so just don't do anything
            if (response.IdleLogoutMinutes > 0) {
                IdleProvider.idle(response.IdleLogoutMinutes * 60); // seconds idle
                IdleProvider.timeout(response.IdleWarningMinutes * 60); // seconds warning
            }
        });
        TitleProvider.enabled(false); // it is enabled by default
        // Set the popover defaults
        $uibTooltipProvider.options = {
            // popupDelay: 10000,
            // popupCloseDelay: 10000,
            animation: true,
            appendToBody: true,
            placement: "top",
            trigger: "mouseenter",
        };
    });

// NOTE: Prepare for upgrade from 1.5 to 1.6 breaking changes
// TODO: Inject $compileProvider after upgrade to 1.6
angular.module("app").config(function ($locationProvider, $qProvider) {
    // Ref: https://docs.angularjs.org/guide/migration#commit-aa077e8
    // TODO: Change links to use !  => needs some investigation
    $locationProvider.hashPrefix("");
    // Ref: https://toddmotto.com/angular-1-6-is-here#ngmodeloptions-and-inheritance
    // Suppress errors when exiting modal with escape
    // Ref: https://github.com/angular-ui/ui-router/issues/2889
    $qProvider.errorOnUnhandledRejections(false);
});

// app config
angular.module("app").config(function (toastrConfig) {
    angular.extend(toastrConfig, {
        autoDismiss: false,
        containerId: "toast-container",
        maxOpened: 0,
        newestOnTop: true,
        positionClass: "toast-bottom-right",
        preventDuplicates: false,
        preventOpenDuplicates: false,
        target: "body",
    });
});

// Propagate the visibilitychange event
angular.module("app").run(function ($rootScope, $document) {
    $document[0].addEventListener("visibilitychange", function () {
        $rootScope.$broadcast("$visibilitychange", $document[0].hidden);
    });
});

angular.module("app").service("locationHistoryService", function () {
    // History can be broken and insecure so better use your own service instead of $window.history.back()
    return {
        previousLocation: null,

        store: function (location) {
            this.previousLocation = location;
        },

        get: function () {
            return this.previousLocation;
        },
    };
});

angular
    .module("app")
    .service("multiTestNotificationService", function ($rootScope) {
        // Use this service to raise events to change UI element/feature availability as test case goes multi run state
        return {
            changeAllOnMultiTestRun: function (val) {
                $rootScope.$broadcast("multiTestRun", val);
            },

            listenForMultiRun: function (sender, handler) {
                sender.$on("multiTestRun", handler);
            },
        };
    });

angular
    .module("app")
    .run(function ($rootScope, $location, locationHistoryService) {
        /* As we are handling $routeChangeStart for login cookie so no need to check user validity here */
        $rootScope.$on("$locationChangeSuccess", function (
            e,
            current,
            previous
        ) {
            locationHistoryService.store(previous);
        });
    });

angular.module('app').config(function ($routeProvider, $locationProvider) {
    $routeProvider
    /**
     * Home page
     * If you need to change the home page for a role then change it in the home.tpl.hml template, not here
     */
    .when('/', {
        template: '<home></home>',
    })

    /**
     * Maintenance
     */
    .when('/Features', {
        template: '<manage-features></manage-features>',
    })
    .when('/lookupGroup', {
        template: '<lookup-group></lookup-group>',
    })
    .when('/lookupGroup/:lookupGroupId', {
        template: '<lookup></lookup>',
    })
    .when('/ProvisionSim', {
        template: '<sim-test-suites></sim-test-suites>',
    })
    .when('/ManageBrands', {
        template: '<manage-brand></manage-brand>',
    })
    .when('/ManageNotifications', {
        template: '<iframe-wrapper src="\'RUF/notifications?embed=true\'"></iframe-wrapper>'
    })
    .when('/ManageProjects', {
        template: '<project-tester-home></project-tester-home>',
    })
    .when('/ManageRepo', {
        template: '<manage-repo></manage-repo>',
    })
    .when('/ManageReports', {
        template: '<manage-reports></manage-reports>',
    })
    .when('/ManageServerControllers', {
        template: '<manage-server-controllers></manage-server-controllers>',
    })
    .when('/ManageSimulationData', {
        template: '<manage-simulation-data></manage-simulation-data>',
    })
    .when('/ManageSimulators/:simulatorId?', {
        template: '<manage-simulators></manage-simulators>',
    })
    .when('/ManageTestSuites', {
        template: '<manage-test-suite></manage-test-suite>',
    })
    .when('/ManageUsers', {
        template: '<user-admin></user-admin>',
    })
    .when('/ReportAccess', {
        templateUrl: 'scripts/app/partials/Admin/ReportAccess.tpl.html',
        controllerAs: '',
        controller: '',
    })
    .when('/ServerExplorer', {
        template: '<iframe-wrapper src="\'RUF/server-explorer?embed=true\'"></iframe-wrapper>'
    })
    .when('/SimulatorDashboard', {
        template: '<sim-dashboard></sim-dashboard>',
    })
    .when('/SystemHealth', {
        template: '<system-health></system-health>',
    })
    .when('/TeamAdmin', {
        template: '<team-admin></team-admin>',
    })
    .when('/UserTestSuites', {
        template:'<user-test-suites></user-test-suites>'
    })
    /**
     * User components
     */
    .when('/Capacity/:userId/:simId', {
        template: '<capacity-home></capacity-home>'
    })
    .when('/ClearingValidation/:userId/:simId', {
        template: '<clearing-validation></clearing-validation>'
    })
    .when('/DataValidator/:testerId', {
        template: '<dv-home></dv-home>',
        reloadOnSearch: false
    })
    .when('/FileValidation/:testerId/:simId?', {
        template: '<dv-home></dv-home>'
    })
    .when('/GtHome/:testerId', {
        template: '<group-tester-home></group-tester-home>'
    })
    .when('/Home', {
        template: '<tester-home></tester-home>',
        reloadOnSearch: false
    })
    .when('/Home/:testerId', {
        template: '<tester-home></tester-home>',
        reloadOnSearch: false
    })
    .when('/Home/:testerId/:simId', {
        template: '<tester-home></tester-home>',
        reloadOnSearch: false
    })
    .when('/Home/:testerId/:simId/:suiteId', {
        template: '<tester-home></tester-home>',
        reloadOnSearch: false
    })
    .when('/ProjectAttachments/:tableName/:tableId', {
        template: '<utp-uploads-controller></utp-uploads-controller>'
    })
    .when('/Reports', {
        templateUrl: 'scripts/app/partials/Reports/Reports.tpl.html',
        controllerAs: 'vm',
        controller: 'ReportsController'
    })
    .when('/Reports/:selectedReport', {
        templateUrl: 'scripts/app/partials/Reports/Reports.tpl.html',
        controllerAs: 'vm',
        controller: 'ReportsController'
    })
    .when('/Reports/:selectedReport/:testerId', {
        templateUrl: 'scripts/app/partials/Reports/Reports.tpl.html',
        controllerAs: 'vm',
        controller: 'ReportsController'
    })
    .when('/Settlement', {
        template: '<settlement-home></settlement-home>'
    })
    .when('/TestExecution/:userId/:simId', {
        template: '<test-execution-view></test-execution-view>',
    })
    .when('/TraceSummary', {
        template: '<trace-summary></trace-summary>'
    })
    .when('/TraceSummary/:testerId', {
        template: '<trace-summary></trace-summary>'
    })
    .when('/TraceSummary/:testerId/:simId', {
        template: '<trace-summary></trace-summary>'
    })
    .when('/TraceSummary/:testerId/:simId/:suiteId', {
        template: '<trace-summary></trace-summary>'
    })
    .when('/DataValidator/:testerId/Uid/:traceUid', {
        template: '<dv-trace-summary></dv-trace-summary>'
    })
    .when('/TraceSummary/Uid/:traceUid', {
        template: '<dv-trace-summary></dv-trace-summary>'
    })
    .when('/TraceSummaryDV/:traceUid', {
        template: '<dv-trace-summary></dv-trace-summary>'
    })
    .when('/TraceSummarySource/:sourcePage/:testerId', {
        template: '<trace-summary></trace-summary>'
    })
    .when('/TraceSummarySource/:sourcePage/:testerId/:simId', {
        template: '<trace-summary></trace-summary>'
    })
    .when('/TraceSummarySource/:sourcePage/:testerId/:simId/:suiteId', {
        template: '<trace-summary></trace-summary>'
    })
    .when('/TestPreparation/:simId', {
        template: '<test-preparation></test-preparation>'
    })  
    .when('/TestPreparation/:simId/:abstractTesterId', {
        template: '<test-preparation></test-preparation>'
    })  
    .when('/Uploads/:tableName/:tableId', {
        template: '<utp-uploads-controller></utp-uploads-controller>'
    })
    .when('/About', {
        template: '<about></about>'
    })
    .when('/BadRoute', {
        templateUrl: 'scripts/app/partials/Support/badRoute.tpl.html'
    })
    .otherwise('/BadRoute', {});

    // NOTE: See https://scotch.io/tutorials/pretty-urls-in-angularjs-removing-the-hashtag
    // NOTE: Set to false until we get rid of the MVC routes
    $locationProvider.html5Mode(false);
});
    
